import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { avgTimeWatchedPerVideoConfig } from '@/lib/analytics/kpis/youtube/avgTimeWatchedPerVideo';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerVideoViewsAvgTimeWatchedConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof KPIDefault
> = {
    ...avgTimeWatchedPerVideoConfig,
    id: 'average_view_duration',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
